import type { IconData } from '@stacksjs/iconify-core'

export const contentBookmark: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M15 0H1v16l7-7l7 7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentBookmark
